import React, { useEffect, useState } from "react";
import NSSelector from "../NSSelector/NSSelector";
import { OptionsRitmoECG, PlatformMobile } from "../../helpers/Constants";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogRitmoInicial = ({
  icon,
  text,
  callbackConfirm,
  callbackCancel,
  status,
}) => {
  const [ritmoEcg, setRitmoEcg] = useState(null);

  const handlerSetOption = (option = null) => {
    setRitmoEcg(option);
  };

  const T = useTranslation();
  const [isOpen, setIsOpen] = useState(status);
  const handlerClose = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerOnConfirm = (ritmo) => {
    if (callbackConfirm) {
      callbackConfirm(ritmo);
    }
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  return (
    <>
      <FloatingDialog isOpen={isOpen} onClose={handlerClose}>
        <div
          style={{
            gap: PlatformMobile ? "10px" : "32px",
            padding: PlatformMobile ? "12px" : "32px",
          }}
          className="flex flex-col w-full h-full items-center justify-center"
        >
          {icon && (
            <div className="rounded flex items-center justify-center text-xl bg-[#2aac9c] w-[32px] h-[32px] text-white border">
              <img src={icon} className="w-full h-full" />
            </div>
          )}
          <span className="font-bold text-center text-base text-[24px] max-w-[430px]">
            {T(text)}
          </span>
          <div className="flex gap-4 overflow-auto w-full">
            <NSSelector
              options={OptionsRitmoECG}
              contexto={"ecg"}
              onCallBack={handlerSetOption}
              oneSelection={true}
              className={" w-full"}
              criticalItems={[0, 1, 2, 3]}
            />
          </div>
          <div className="flex w-full  justify-center  mb-6 ">
            <SimpleButton
              text={T("Confirmar")}
              onClick={() => handlerOnConfirm(ritmoEcg)}
              disabled={ritmoEcg == null}
            />
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogRitmoInicial;
